import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";
import { applyPendingAuthContinuation } from "./support/auth_continuation"


export default class extends Controller {
    connect() {
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: true,
            lockForm: true,
            focusInvalidField: true,
            errorFieldCssClass: 'is-invalid',
        });

        const emailSelector = "#login-page-form input[name$='[username]']";
        const passwordSelector = "#login-page-form input[name$='[password]']";

        this.validator
            .addField(emailSelector, [
                {rule: 'required', errorMessage: 'Email address is required'},
                {rule: 'email', errorMessage: 'Please enter a valid email address'},
            ])
            .addField(passwordSelector, [
                {rule: 'required', errorMessage: 'Password is required'},
            ])
            .onSuccess((event) => {
                applyPendingAuthContinuation(event.target)
                event.target.submit();
            });
    }

    disconnect() {
        if (this.validator?.destroy) this.validator.destroy();
    }
}
